import {put,takeLatest,call} from 'redux-saga/effects';
import * as orderService from "../../../services/orderService";
import {
    LOAD_MORE_ORDERS_OF_USER,
    LOAD_MORE_ORDERS_OF_USER_SUCCESS,
    LOAD_MORE_ORDERS_OF_USER_ERROR
}
    from "../../actions/order";
function* loadMoreOrdersOfUserSaga(action) {
    try {
        const data=yield call(orderService.GetOrdersOfUser,action.payload)
        yield put({
            type: LOAD_MORE_ORDERS_OF_USER_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: LOAD_MORE_ORDERS_OF_USER_ERROR,error: error.data
        });
    }
}

export function* loadMoreOrdersOfUserSagaWatcher() {
    yield takeLatest(LOAD_MORE_ORDERS_OF_USER,loadMoreOrdersOfUserSaga);
}